export interface IAdminTypeDto {
  id?: string;
  adminTypeName: string;
  permission: any[];
  status: string;
}
